export default "__VITE_ASSET__CGKhN7An__"